const acDomain = 'https://ad-c.origin.veyasoft.com'
export default acDomain
